module.exports = __webpack_public_path__ + "static/scale-model-of-the-golden-triangle-in-los-angeles-california-ed3e493c746f36acde26086c48c7e62b.png";